import { keyframes } from 'styled-components';
import { styled } from '../../../core/theme/styled';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';

export const Header = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.sizes.normal};
  position: absolute;
  top: 0;
  left: 0;
`;

export const TintedScreenWrapper = styled(ScreenWrapper)`
  background-color: ${({ theme }) => theme.configuration.tintedBackgroundColor};
`;

export const LayoutContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const ContentContainer = styled.div`
  height: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
`;

export const MainContent = styled.div`
  width: 80%;
`;

const fadeIn = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;

export const Footer = styled.footer`
  animation: ${fadeIn} 350ms ease-in;
`;
